import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { baseURL } from "@/utility/api";
import axios from "axios";
import PlacementHero from "../../components/PlacementComponents/PlacementHero";
import PlacementWhatYoullGet from "../../components/PlacementComponents/PlacementWhatYoullGet";
import PlacementWhoShouldApply from "@/components/PlacementComponents/PlacementWhoShouldApply";
import PlacementSelectionProcess from "@/components/PlacementComponents/PlacementSelectionProcess";

import PlacementTestimonial from "@/components/PlacementComponents/PlacementTestimonial";
import PlacementFAQ from "@/components/PlacementComponents/PlacementFAQ";
import PlacementFinal from "@/components/PlacementComponents/PlacementFinal";

const PlacementCohortPage = () => {
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      const response = await axios.post(`${baseURL}/cohort/get-details`, {
        id: 108,
      });
      setDetails(response.data);
    };
    fetchDetails();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white font-inter px-0 md:px-0">
      <PlacementHero details={details} />
      <PlacementWhatYoullGet details={details} />
      <PlacementWhoShouldApply />
      <PlacementSelectionProcess details={details} />

      <PlacementTestimonial />
      <PlacementFAQ />
      <PlacementFinal />
    </div>
  );
};

export default PlacementCohortPage;
